import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { toLower, startCase, some, isEmpty } from 'lodash';
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useHistory,
} from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import queryString from 'query-string';

import { refreshReloadPrompt } from 'hooks';
import { useAuth } from 'context/AuthContext';
import Login from 'components/pages/Login';
import { routes } from 'routes';
import SideBar from 'components/general/SideBar';
import AppointmentScheduler from 'components/pages/AppointmentScheduler';
import AppointmentCancel from 'components/pages/AppointmentCancel';
import { PageTitle, Layout, Content } from './styles';

const App = () => {
  const history = useHistory();
  const { currentUser, setCurrentUser } = useAuth();
  const { pathname } = useLocation();

  const subdomain = window.location.hostname;
  const developmentEnv = process.env.NODE_ENV === 'development';
  console.log(developmentEnv);

  const [isIdle, setIsIdle] = useState(false);
  const timeout = 15 * 60 * 1000;

  useIdleTimer({
    timeout,
    onActive: () => setIsIdle(false),
    onIdle: () => setIsIdle(true),
  });

  useEffect(() => {
    const tokenExpiration = localStorage.getItem('token_expiration');
    const tokenIsExpired = moment().isAfter(moment(tokenExpiration));

    // Log user out if token expired
    if (tokenIsExpired) {
      localStorage.removeItem('token');
      localStorage.removeItem('token_expiration');
      setCurrentUser();
    }

    // Set token expiration
    if (currentUser) {
      localStorage.setItem(
        'token_expiration',
        moment().add(15, 'minutes').toDate(),
      );
    }

    // Log user out if user inactive
    if (currentUser && isIdle) {
      localStorage.removeItem('token');
      localStorage.removeItem('token_expiration');
      setCurrentUser();
      window.removeEventListener('beforeunload', refreshReloadPrompt);
    }
  }, [isIdle, currentUser]);

  const title = startCase(toLower(pathname.split('/')[1]));

  const notAppointmentPage = some(routes, ({ path }) =>
    pathname.includes(path),
  );

  if (subdomain.includes('book')) {
    console.log('/--------- LOADING APP -----------/');
    return (
      <Layout>
        <Content disablePadding>
          <Switch>
            <Route
              path="/"
              render={(params) => {
                const parsedParams = queryString.parse(params.location.search);

                if (parsedParams.id) {
                  return <AppointmentCancel />;
                }

                return <AppointmentScheduler />;
              }}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }

  if (developmentEnv || subdomain.includes('admin')) {
    if (currentUser) {
      console.log('/--------- LOADING DASHBOARD -----------/');
      return (
        <Layout>
          {notAppointmentPage && <SideBar />}

          <Content>
            {notAppointmentPage && <PageTitle>{title}</PageTitle>}

            <Switch>
              {routes.map(({ path, component, exact }) => (
                <Route
                  key={path}
                  path={path}
                  component={component}
                  exact={exact}
                />
              ))}

              <Route render={() => <Redirect to="/clinics" />} />
            </Switch>
          </Content>
        </Layout>
      );
    }

    console.log('/--------- LOADING LOGIN -----------/');
    return (
      <>
        <Login history={history} />
        <Redirect to="/login" />
      </>
    );
  }

  if (subdomain.includes('app')) {
    return null;
  }

  return <h1>404</h1>;
};

export default App;
